import { useState } from "react";
import { HiDownload, HiCheck } from "react-icons/hi";
import { CgSpinner } from "react-icons/cg";
import * as types from "types";
import {
  downloadFile,
  downloadLegacyFile,
} from "services/cortevaChain/methods/downloadFile";
import useGetAccessToken from "components/Login/useGetAccessToken";
import saveBlob from "utilities/saveBlob";
import styles from "./Message.module.scss";

interface DownloadFileButtonProps {
  chatThread: types.ChatThread;
  fileName: string;
  permalink?: string | null;
}

export default function DownloadFileButton({
  chatThread,
  fileName,
  permalink,
}: DownloadFileButtonProps) {
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloaded, setIsDownloaded] = useState(false);

  const getAccessToken = useGetAccessToken();

  const handleDownload = async () => {
    if (isDownloading) return;

    try {
      setIsDownloading(true);
      let blob;
      if (!permalink) {
        blob = await downloadLegacyFile(
          fileName,
          chatThread.id,
          getAccessToken
        );
      } else {
        blob = await downloadFile(permalink, getAccessToken);
      }

      saveBlob(blob, fileName);

      setIsDownloaded(true);
      setTimeout(() => setIsDownloaded(false), 2000);
    } catch (error) {
      console.error("Failed to download file:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const renderIcon = () => {
    if (isDownloading) {
      return (
        <CgSpinner size={18} style={{ animation: "spin 1s linear infinite" }} />
      );
    }
    if (isDownloaded) return <HiCheck size={18} />;
    return <HiDownload size={18} />;
  };

  return (
    <button
      className={`${styles.deleteFile} bg-transparent bn pa0 dim pointer gray`}
      onClick={handleDownload}
      disabled={isDownloading}
      title="Download file"
    >
      {renderIcon()}
    </button>
  );
}
